import {FilledCreditCardIcon, Typography, UnstableCard as Paper} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import type {ReactElement} from 'react'

import {Body, Header} from '../../components/desktop'
import type {PaymentMethodWidgetProps as Props} from '../types'
import {PaymentCard} from './components/PaymentCard/index@desktop'
import {usePaymentMethodProps} from './hooks/usePaymentMethodProps'
import * as classes from './PaymentMethod@desktop.classes'

export function PaymentMethod(props: Props): ReactElement {
  const i18n = useI18n()
  const {fieldName, getBody} = usePaymentMethodProps(props)

  return (
    <Paper className={classes.paper} radius="L">
      <Body tail={<PaymentCard getBody={getBody} name={fieldName} title={null} />}>
        <Header className={classes.header} lead={<FilledCreditCardIcon />}>
          <Typography group="normal" thickness="medium" variant="title4">
            {i18n('ndd.payment.title', 'Оплата')}
          </Typography>
        </Header>
      </Body>
    </Paper>
  )
}
